import type { ReactNode } from 'react';
import styled from 'styled-components';

import {
  Accordion,
  type AccordionChildren,
} from '#src/atoms/layout/accordion/index.tsx';

type Props = {
  title?: ReactNode;
  children: AccordionChildren;
  startsOpen?: boolean;
};

const Wrapper = styled(Accordion.Wrapper)`
  color: var(--c-white);
`;

const Title = styled(Accordion.Title)`
  gap: var(--double-unit);
  padding: var(--intermediate-unit) var(--double-unit);
  transition: all 0.3s;
  &:hover {
    background-color: var(--c-nd-100);
  }
`;

const Details = styled(Accordion.Details)`
  padding: var(--double-unit);
`;

const TitlelessContent = styled.div`
  color: var(--c-white);
  padding: var(--intermediate-unit) var(--double-unit) var(--double-unit);
`;

export const FilterAccordion = ({ title, children, startsOpen }: Props) => {
  if (!title) {
    return (
      <TitlelessContent>
        {typeof children === 'function'
          ? children({ expanded: true })
          : children}
      </TitlelessContent>
    );
  }

  return (
    <Wrapper defaultExpanded={startsOpen}>
      <Title>{title}</Title>
      <Details>{children}</Details>
    </Wrapper>
  );
};
